module.exports = __webpack_public_path__ + "media/images/howitworks-art-1-eade2cc2e7c3406fa6d65ebc4869b60c.svg";